import {computed, ref} from 'vue'
import {usePosEventBus} from '~/composables/usePosEventBus'

const KDS_HEARTBEAT_TIMEOUT = 60000
const KDS_HEARTBEAT_INTERVAL = 30000

const kdsLastSeen = ref(null)
const kdsDeviceId = ref(null)
// Reactive clock so isKdsOnline re-evaluates on a schedule. Date.now() is not reactive,
// so without this the computed would stay true forever after the first heartbeat.
const currentTime = ref(Date.now())
let statusCheckInterval = null
let isListenerRegistered = false

export const useKdsDetection = () => {
    const {onKdsHeartbeat, offKdsHeartbeat} = usePosEventBus()

    const isKdsOnline = computed(() => {
        if (!kdsLastSeen.value) return false
        return currentTime.value - kdsLastSeen.value < KDS_HEARTBEAT_TIMEOUT
    })

    const handleKdsHeartbeat = (payload) => {
        kdsLastSeen.value = Date.now()
        kdsDeviceId.value = payload?.deviceId || null
        console.log('[KDS Detection] 💓 Heartbeat received from KDS:', payload?.deviceId)
    }

    const resetKdsStatus = () => {
        kdsLastSeen.value = null
        kdsDeviceId.value = null
    }

    const getKdsStatus = () => {
        return {
            isOnline: isKdsOnline.value,
            lastSeen: kdsLastSeen.value,
            deviceId: kdsDeviceId.value,
        }
    }

    const startListening = () => {
        if (isListenerRegistered) return

        onKdsHeartbeat(handleKdsHeartbeat)
        isListenerRegistered = true
        console.log('[KDS Detection] Started listening for KDS heartbeats')

        if (!statusCheckInterval) {
            statusCheckInterval = setInterval(() => {
                currentTime.value = Date.now()
            }, KDS_HEARTBEAT_INTERVAL)
        }
    }

    const stopListening = () => {
        if (!isListenerRegistered) return

        offKdsHeartbeat(handleKdsHeartbeat)
        isListenerRegistered = false

        if (statusCheckInterval) {
            clearInterval(statusCheckInterval)
            statusCheckInterval = null
        }
        console.log('[KDS Detection] Stopped listening for KDS heartbeats')
    }

    return {
        isKdsOnline,
        kdsLastSeen,
        kdsDeviceId,
        handleKdsHeartbeat,
        resetKdsStatus,
        getKdsStatus,
        startListening,
        stopListening,
        KDS_HEARTBEAT_INTERVAL,
        KDS_HEARTBEAT_TIMEOUT,
    }
}
